import { t } from "@lingui/macro";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  KeyboardShortcut,
} from "@my-saas/ui";
import { useNavigate } from "react-router";

import { changeLanguage } from "../providers/locale";
import { useLogout } from "../services/auth";

type Props = {
  children: React.ReactNode;
};

// Compact language picker — full list lives in @my-saas/utils.languages but
// for the dropdown we surface the most-common pair plus a few extras.
const QUICK_LOCALES: { code: string; label: string }[] = [
  { code: "en-US", label: "English" },
  { code: "he-IL", label: "עברית (Hebrew)" },
  { code: "ar-SA", label: "العربية (Arabic)" },
  { code: "ru-RU", label: "Русский (Russian)" },
];

export const UserOptions = ({ children }: Props) => {
  const navigate = useNavigate();
  const { logout } = useLogout();
  const activeLocale = window.localStorage.getItem("locale") ?? "en-US";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>

      <DropdownMenuContent side="top" align="start" className="w-56">
        <DropdownMenuItem
          onClick={() => {
            void navigate("/dashboard/settings");
          }}
        >
          {t`Settings`}
          {/* eslint-disable-next-line lingui/no-unlocalized-strings */}
          <KeyboardShortcut>⇧S</KeyboardShortcut>
        </DropdownMenuItem>

        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs uppercase tracking-wider text-muted-foreground">
          {t`Language`}
        </DropdownMenuLabel>
        {QUICK_LOCALES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => void changeLanguage(l.code)}
            className={activeLocale === l.code ? "font-medium" : undefined}
          >
            {l.label}
            {activeLocale === l.code && <span className="ml-auto text-xs">✓</span>}
          </DropdownMenuItem>
        ))}

        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => logout()}>
          {t`Logout`}
          {/* eslint-disable-next-line lingui/no-unlocalized-strings */}
          <KeyboardShortcut>⇧Q</KeyboardShortcut>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
